/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";
import { CreateTHEADSection } from "@/common/common.js";

export function InitializeRTSStep4Page() {
     var onSubmit = false;
     customValidationInit(onSubmit);
     aspControlValidationInit();

     // create the thead section for the datagrid since datagrids don't natively have it. 
     CreateTHEADSection("dgAttachments");

     //responsive table
     $('.responsiveTable').DataTable({
        "responsive": true,
        "scrollX": false,
        "paging": false,
        "searching": false,
        "ordering": false,
        "info": false

   });
};
